import $ from 'jquery';

$(function() {
  if (document.getElementById('nicotineWarning')) {
    run();
    window.addEventListener('scroll', run);
    window.addEventListener('resize', run);
  }
});

const run = () => {
  updateStickyNav();
  updateSideBarHeight();
};

const updateSideBarHeight = () => {
  const cartSideBar = document.getElementsByClassName('CartSidebar')[0];
  const navSideBar = document.getElementsByClassName('header__sidenav')[0];
  const headerHeight = document
    .getElementById('header__container')
    .getBoundingClientRect().bottom;
  const newCartHeight = window.innerHeight - headerHeight;
  cartSideBar.style.height = `${newCartHeight}px`;
  navSideBar.style.height = `${newCartHeight}px`;
};

const updateStickyNav = () => {
  const offset = document.getElementById('nicotineWarning').offsetHeight;
  const bodyContent = document.getElementsByClassName('body__content')[0];

  if (window.pageYOffset >= offset) {
    // headers stick to the top once the nicotine warning scrolls off the page
    headerPosition('fixed');
    bodyContent.classList.remove('no-padding');
  } else {
    // headers scroll with page when nicotine warning is visible
    headerPosition('relative');
    bodyContent.classList.add('no-padding');
  }
};

const headerPosition = position => {
  const headers = document.getElementsByClassName('header__nav-wrapper');
  Array.prototype.forEach.call(headers, function(el) {
    el.style.position = position;
  });
};



// WEBPACK FOOTER //
// ./app/javascript/apps/application/nicotineWarning.js